import { Link } from 'react-router-dom';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { useTranslation } from 'react-i18next';

export default function ForgetPassword() {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();
  const { t } = useTranslation("global");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      toast.error(t("forgetPassword.errors.required"));
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/forget-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });
      

      const result = await response.json();

      if (result && result.code === 200) {
        localStorage.setItem("otpAllowed", "true");
        localStorage.setItem("user", JSON.stringify(result));

        toast.success(t("forgetPassword.messages.otpSent"), {
          autoClose: 2000,
          onClose: () => {
            navigate("/verify-otp", { state: { email } });
          },
        });
      } else {
        toast.error(result.message || t("forgetPassword.errors.failed"));
      }
    } catch (error) {
      toast.error(t("forgetPassword.errors.network"));
    }
  };

  return (
    <section style={{ backgroundColor: '#193C6E', minHeight: '100vh' }}>
      <ToastContainer />

      <div className="container h-100">
        <div className="row d-flex justify-content-center align-items-center min-vh-100">
          <div className="col-lg-6 col-md-12">
            <img src="assets/imgs/layer 2.png" width="100%" alt="Forget Password" />
          </div>
          <div className="col-lg-6 col-md-12">
            <div className="card-singin p-4 shadow rounded-4">
              <div>
                <img src="assets/imgs/تميز copy 1.svg" alt="Taamayaz Logo" className="mb-3" />
                <h2 className="second-color ">{t("forgetPassword.title")}</h2>
                <p className="paragraph-color ">{t("forgetPassword.description")}</p>
              </div>

              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-12 col-lg-12">
                    <label className=" d-block mb-2" htmlFor="email">
                      {t("forgetPassword.emailLabel")}
                    </label>
                    <input
                      type="email"
                      id="email"
                      className="form-control mb-2"
                      placeholder={t("forgetPassword.emailPlaceholder")}
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                </div>

                <button type="submit" style={{ backgroundColor: '#352E64', color: '#fff' }} className="btn w-100 py-2 my-3">
                  {t("forgetPassword.continueButton")}
                </button>
              </form>

              <p style={{ color: '#352E64' }} className="text-center mt-3">
                {t("forgetPassword.alreadyHaveAccount")}{" "}
                <Link to="/login" className="fw-bold">
                  {t("forgetPassword.signIn")}
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
